import {GrantStatus} from 'src/openapi/admin/models/GrantStatus';


export const SELECTION_KEY = 'entitlements';

export const NO_ASSIGNED_ENTITLEMENT_TITLE =
    'There are currently no resources in the system ' +
    'Please add a new resource to the system';

export const NO_ASSIGNED_ENTITLEMENT_DESCRIPTION =
    'If you do not have access to the "Create Resource(s)" page, ' +
    'Please reach out to the Entitlement team to request an entitlement update.';
export const SECTION_NAME = 'Account Entitlements';

export const GRANT_STATUS_CAPTIONS: Record<string, string> = {
    [GrantStatus.ALLOW]: 'Allow',
    [GrantStatus.DENY]: 'Deny',
};

export const COLUMNS = {
    TITLE: 'title',
    DESCRIPTION: 'description',
    GRANT: 'grant',
    STATUS: 'status',
    RESTRICTION: 'restriction',
};

export const HEADERS = {
    [COLUMNS.TITLE]: 'Role/Resource',
    [COLUMNS.DESCRIPTION]: 'Description',
    [COLUMNS.GRANT]: 'Entitlement Grant',
    [COLUMNS.STATUS]: 'Status',
    [COLUMNS.RESTRICTION]: 'Restriction',
};

export const COLUMNS_DATA = [
    {
        columnId: COLUMNS.TITLE,
        fixed: true,
        defaultWidth: 450,
        minWidth: 400,
        maxWidth: 500,
    },
    {
        columnId: COLUMNS.DESCRIPTION,
        fixed: false,
        defaultWidth: 450,
        minWidth: 400,
        maxWidth: 500,
    },
    {
        columnId: COLUMNS.GRANT,
        fixed: false,
        defaultWidth: 400,
        minWidth: 350,
        maxWidth: 500,
    },
    {
        columnId: COLUMNS.STATUS,
        fixed: false,
        defaultWidth: 200,
        minWidth: 200,
        maxWidth: 400,
    },
    {
        columnId: COLUMNS.RESTRICTION,
        fixed: false,
        defaultWidth: 260,
        minWidth: 260,
        maxWidth: 500,
    },
];
